export default __webpack_public_path__ + "static/media/logod-arts-main2.8c2107f4.svg";